<ng-container *transloco="let t; read: 'user'">
<div class="p-5">
    <drdp-title [title]="t('dashboard.portfolio.title')" [tutorialUrls]="[
      {url: 'https://www.youtube.com/watch?v=6gna0DGIfc4', label: t('dashboard.portfolio.tutorials.overview')},
      {url: 'https://www.youtube.com/watch?v=pU-8f9Pm2NE', label: t('dashboard.portfolio.tutorials.uploadEvidence')},
      {url: 'https://youtu.be/TJeTL0_WvpA', label: t('dashboard.portfolio.tutorials.futureEvidence')}
    ]"></drdp-title>

    <drdp-container>
        <drdp-container color="lightBlue">
            <div class="p-3 flex grid md:grid-cols-5 gap-2 flex-row content-between">
                <ng-container class="contents">
                    <div class="col-span-1 z-50">
                        <drdp-select-state #stateSelect [initialStateId]="initStateId" (state)="handleState($event)"
                            [required]="true" [clear]="cleardropDown" [disabled]="!isSuperUser">
                        </drdp-select-state>
                    </div>
                    <div class="col-span-1 z-50">
                        <drdp-select-agency #agencySelect (agency)="handleChosenAgency($event)" [stateId]="stateId.value"
                            [initialAgencyId]="initAgencyId" [required]="true" [clear]="cleardropDown">
                        </drdp-select-agency>
                    </div>
                    <div class="col-span-1 z-50">
                        <drdp-select-site #sitesSelect (site)="handleChosenSite($event)" [agencyId]="agencyId.value"
                            [multiSelect]="false" [multiSelectInitVals]="false" [required]="true" [clear]="cleardropDown">
                        </drdp-select-site>
                    </div>
                    <div class="col-span-1 z-50">
                        <drdp-select-rating-period (ratingPeriod)="handleChosenRatingPeriod($event)"
                                   [initialRatingPeriodId]="ratingPeriodId.value"
                                   [agencyId]="agencyId.value"
                                   [required]="true"
                                   [clear]="cleardropDown">
        </drdp-select-rating-period>
                    </div>
                    <div class="col-span-1 z-40">
                        <drdp-filter-select #classroomSelect [label]="t('dashboard.portfolio.filters.classroom')" [options]="classroomList"
                            [selectType]="select.Class" (onSelected)="handleChosenClassroom($event)">
                        </drdp-filter-select>
                    </div>
                    <div class="col-span-1 z-40">
                        <drdp-select-age-grade #ageGroupInstrumentSelect [initialageGradeId]="ageGroupInstrumentId.value" [stateId]="stateId.value" [label]="t('dashboard.portfolio.filters.ageGroupInstrument')"
                            [multiSelect]="false" [required]="true" [includePilot]="include2025AgeGrades"
                            [schoolYearId]="selectedSchoolYearId"
                            (ageGrade)="handleAgeGroupInstrument($event)" [clear]="cleardropDown">
                        </drdp-select-age-grade>
                    </div>
                    <div class="col-span-1 md:col-start-5 self-end justify-center md:justify-self-end">
                        <drdp-btn type="submit" (click)="submit()" class="mr-2">{{ t('dashboard.portfolio.actions.search') }}</drdp-btn>
                        <drdp-btn type="button" (click)="clear()" color="outline">{{ t('dashboard.portfolio.actions.clear') }}</drdp-btn>
                    </div>
                </ng-container>
            </div>
        </drdp-container>
        <div class="p-5 w-full">
            <drdp-add-edit-table viewIcon="uil uil-file-alt text-drdpblue-300" [dataSource]="dataSource" [tableData]="tableData"
                [columns]="tableColumns" (viewActionItem)="viewStudents($event)" (iconActionItem)="viewClass($event)">
            </drdp-add-edit-table>
        </div>
    </drdp-container>
</div>
<mat-paginator class="pb-6" [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [length]="totalData" [pageIndex]="pageIndex"
    (page)="paginateTable($event)">
</mat-paginator>
</ng-container>
